import { c as _c } from "react/compiler-runtime";
import { DialogTitle } from '@headlessui/react';
import { ArrowLeft } from '@phosphor-icons/react';
import type { Variants } from 'motion/react';
import { AnimatePresence } from 'motion/react';
import * as m from 'motion/react-m';
import type { ReactNode } from 'react';
import { useMediaState } from '../../../hooks/use-media-state';
import { uiTestId } from '../../../test-ids';
import { IconButton } from '../../button/icon-button';
import { CloseIcon } from '../modal-header';
export type SlidesHeaderProps = {
  title?: ReactNode;
  animate?: boolean;
  onClose: VoidFunction;
  onBackClick?: VoidFunction;
};
const variants: Variants = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
};
export const SlidesHeader = t0 => {
  const $ = _c(19);
  const {
    title,
    animate,
    onClose,
    onBackClick
  } = t0;
  const isMobile = useMediaState("mobile");
  if (!title) {
    return null;
  }
  const t1 = String(animate);
  let t2;
  if ($[0] !== isMobile) {
    t2 = isMobile ? variants : {};
    $[0] = isMobile;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.2
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onBackClick) {
    t4 = onBackClick && <IconButton weight="ghost" Icon={BackIcon} onClick={onBackClick} data-testid={uiTestId("Modal.Header.back")} aria-label={"Zur\xFCck zur vorherigen Eingabe"} />;
    $[3] = onBackClick;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== title) {
    t5 = <DialogTitle as="h3" className="text-center font-heading4">{title}</DialogTitle>;
    $[5] = title;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="p-6" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t4 || $[11] !== t5) {
    t7 = <AnimatePresence mode="wait"><m.div className="flex items-center justify-between gap-2" key={t1} variants={t2} initial="initial" animate="animate" exit="exit" transition={t3}>{t4}{t5}{t6}</m.div></AnimatePresence>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = uiTestId("Modal.Header.close");
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== onClose) {
    t9 = <div className="absolute top-6 right-6"><CloseIcon onClick={onClose} data-testid={t8} /></div>;
    $[14] = onClose;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7 || $[17] !== t9) {
    t10 = <div className="relative z-50 bg-white px-6 pt-6 pb-2 sm:px-8">{t7}{t9}</div>;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
const BackIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ArrowLeft size={24} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};